import config from "../config/app.conf.json";

export default data => ({
  url: config.api.recoveryquestion + data,
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  }
});
